<template>
    <div class="step2">
        <div class="tishi">
            <div class="intro-student">
                <img src="@/assets/images/step/pic2.jpg" class="fl">
                <div class="fl">
                    <p>姓&#12288;&#12288;名：15735346353</p>
                    <p>性&#12288;&#12288;别：***</p>
                    <p>准考证号：11111111</p>
                    <p>证件号码：11111111111111111</p>
                </div>
            </div>
            <div class="time fr">
                <timer
                  v-if="endTimes>=0"
                  :end-times.sync="endTimes"
                  description="离考试开始还有"
                  @submit="examStart"/>&nbsp;
                <a href="javascript:void (0);" @click="examStart">马上做题</a>
            </div>
            <div class="clear"/>
            <h3><img src="@/assets/images/step/title.png"></h3>
            <div class="tex_warp">
                <div class="tex">
                  <div v-show="showInfo"
                      class="mk">
                    <div class="con">
                      <iframe scrolling="auto"
                              frameborder="0"
                              marginwidth="10"
                              marginheight="10"
                              src="//www.jianshe99.com/jianzao2/zhuanti/jkxt/ksxz/"
                              height="100%"
                              width="100%" />
                    </div>
                  </div>
                  <div class="mk"
                      v-show="!showInfo">
                    <div class="con">
                      <iframe scrolling="auto"
                              frameborder="0"
                              marginwidth="10"
                              marginheight="10"
                              src="//www.jianshe99.com/jianzao2/zhuanti/jkxt/czsm/"
                              height="100%"
                              width="100%" />
                    </div>
                  </div>
                </div>
                <div class="btn">
                    <a href="javascript:void(0);" @click="change(0)" class="a1" target="_self">考生须知</a>
                    <a href="javascript:void(0);" @click="change(1);" class="a1" target="_self">操作说明</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { setPageTitle, isEmptyObject, parseNumber,getCookie } from "@/utils"
  import { checkTempPaper } from '@api'
  import {Timer} from '@components/exam'
  export default {
    name: 'Step2',
    components: {
      Timer
    },
    computed: {
      ...mapGetters([
        'siteData'
      ]),
    },
    data() {
      return {
        courseInfo: {},
        siteCourseID: '',
        courseID: '',
        zkzID:'',
        showInfo: true,
        questions:[],
        commonInfo:{},
        endTimes:120
      }
    },
    async mounted() {
      const { flag } = this.$route.params
      let _flag = flag === 'paidExam' ? '' : flag
      const { siteCourseID, courseID, zkzID} = this.$route.query
      const { majorID } = this.$categoryInfo
      this.siteCourseID = parseNumber(siteCourseID)
      this.courseID = courseID
      this.zkzID = zkzID

      if (isEmptyObject(this.siteData)) {
        let params = {
          flag: _flag,
          majorID: majorID,
          siteCourseID: this.siteCourseID
        }
        await this.$store.dispatch('getCurrentSiteInfo', params)
          .then(res => {
            this.courseInfo = res.currentCourse
          })
          .catch(err => {
            this.$message.error(err.msg)
          })
      } else {
        this.courseInfo = this.siteData.currentCourse
      }
      document.title = setPageTitle(this.courseInfo.siteCourseName)
    },
    methods: {
      change (type) {
        if (type === 0) {
          this.showInfo = true
        } else if (type === 1) {
          this.showInfo = false
        }
      },
      examStart() {
        let uid = getCookie('cdeluid') || ''
        let params = {
          siteCourseID: this.siteCourseID,
          flag: this.flag,
          userID: parseNumber(uid)
        }
        // 查询是否有临时保存试题
        checkTempPaper(params).then(res => {
          const { flag } = this.$route.params
          if (res.length > 0) {
            const tempData = res[0]
            let _confirm = confirm('请确认 ：是否继续上次未完成的试卷?\n按“确定”将打开上次的试卷\n按“取消”则打开新试卷')
            if (_confirm) {
              return this.$router.push({
                path: `/${flag}/doExam`,
                query: {
                  siteCourseID: this.siteCourseID,
                  courseID: this.courseID,
                  bizID: String(tempData.bizID),
                  spendTime: String(tempData.spendTime),
                  temp: '2'
                }
              })
            } else {
              return this.$router.push({
                path: `/${flag}/doExam`,
                query: {
                  siteCourseID: this.siteCourseID,
                  courseID: this.courseID,
                  // bizID: String(tempData.bizID),
                  spendTime: 0,
                  temp: '1',
                  includeTempButAbandon: '1'
                }
              })
            }
          }
          return this.$router.push({
            path: `/${flag}/doExam`,
            query: {
              siteCourseID: this.siteCourseID,
              courseID: this.courseID,
              temp: '1'
            }
          })
        })
      }

    }
  }
</script>
